// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NextGen_nextGenHeading__Jhvdi {
  color: #000;
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  /* margin: 0 2.8em; */
  margin-top: 2rem;
  margin-bottom: 1.7rem;
}
.NextGen_nextGenHeading__Jhvdi span {
  font-weight: 700;
}

.NextGen_nextGenImageBox__T-ARk {
  display: flex;
  justify-content: center;
  align-items: center;
}
.NextGen_nextGenImage__RVGyd {
  width: 90%;
}

.NextGen_nextGenKeyPointsContainer__svdka {
  width: 85%;
  height: 13rem;
  border-radius: 1.9375rem;
  background: #f5faff;
  position: relative;
  margin: 40px 0;
}
.NextGen_nextGenKeypoint__9BP60 {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6rem;
  height: 6rem;
}
.NextGen_nextGenKeypoint__9BP60 img {
  width: 100%;
}
.NextGen_nextGenKeypointsHeading__bz3mI {
  font-family: Roboto;
  color: #000;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  padding-top: 60px;
}

.NextGen_nextGenKeyPointTitle__AUV2C {
  font-family: Roboto;
  opacity: 0.8;
  color: #545454;
  text-align: center;
  font-size: 0.85rem;
  font-weight: 300;
  line-height: 1.3;
  margin: 0 20px;
  margin-top: -10px;
}

.NextGen_nextGenKeypointContainerBox__7P7\\+3 {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/MobileHomePage/NextGen/NextGen.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".nextGenHeading {\n  color: #000;\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 400;\n  /* margin: 0 2.8em; */\n  margin-top: 2rem;\n  margin-bottom: 1.7rem;\n}\n.nextGenHeading span {\n  font-weight: 700;\n}\n\n.nextGenImageBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.nextGenImage {\n  width: 90%;\n}\n\n.nextGenKeyPointsContainer {\n  width: 85%;\n  height: 13rem;\n  border-radius: 1.9375rem;\n  background: #f5faff;\n  position: relative;\n  margin: 40px 0;\n}\n.nextGenKeypoint {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 6rem;\n  height: 6rem;\n}\n.nextGenKeypoint img {\n  width: 100%;\n}\n.nextGenKeypointsHeading {\n  font-family: Roboto;\n  color: #000;\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 600;\n  padding-top: 60px;\n}\n\n.nextGenKeyPointTitle {\n  font-family: Roboto;\n  opacity: 0.8;\n  color: #545454;\n  text-align: center;\n  font-size: 0.85rem;\n  font-weight: 300;\n  line-height: 1.3;\n  margin: 0 20px;\n  margin-top: -10px;\n}\n\n.nextGenKeypointContainerBox {\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nextGenHeading": `NextGen_nextGenHeading__Jhvdi`,
	"nextGenImageBox": `NextGen_nextGenImageBox__T-ARk`,
	"nextGenImage": `NextGen_nextGenImage__RVGyd`,
	"nextGenKeyPointsContainer": `NextGen_nextGenKeyPointsContainer__svdka`,
	"nextGenKeypoint": `NextGen_nextGenKeypoint__9BP60`,
	"nextGenKeypointsHeading": `NextGen_nextGenKeypointsHeading__bz3mI`,
	"nextGenKeyPointTitle": `NextGen_nextGenKeyPointTitle__AUV2C`,
	"nextGenKeypointContainerBox": `NextGen_nextGenKeypointContainerBox__7P7+3`
};
export default ___CSS_LOADER_EXPORT___;
